'use strict';

angular.module('msCore').controller('GetHelpCtrl', GetHelpCtrl);

GetHelpCtrl.$inject = ['$sce', 'userSvc', 'providerSvc', 'AuditSvc', '$filter', '$log'];

function GetHelpCtrl($sce, userSvc, providerSvc, AuditSvc, $filter, $log) {
  var vm = this;
  var $headerHtml = $filter('headerHtml');

  // Set VM variable initial values
  vm.clientOfferingVersion = 'MY1_0';
  vm.cobrandingText = '';
  vm.cobranding = null;
  vm.leftSide = null;
  vm.rightSide = null;
  vm.showTelehealth = false;
  vm.telehealthProvider = null;
  vm.sendTelehealthAnalyticLinkVisit = sendTelehealthAnalyticLinkVisit;

  init();

  function init() {
    userSvc.getUser().then(function (user) {
      setCobranding(user);
      setClientOfferingVersion(user);
      setGetHelpContent(user);
      setTelehealthContent(user);
    });
  }

  function setClientOfferingVersion(user) {
    vm.clientOfferingVersion = user.clientOfferingVersion;
  }

  function setCobranding(user) {
    vm.cobrandingText = user && user.organization ? user.organization.name : '';

    providerSvc.getHeaderImage().then(function (data) {
      vm.cobranding = data ? data : null;
    });
  }

  function setGetHelpContent(user) {
    // Get header and use to set get help content
    providerSvc.getHeader().then(function (resp) {
      var div = document.createElement('div');
      resp.content.push({
        target: 'payerGroupPhonenumber',
        replacement: user.accessCode.phoneNumber
      });

      div.innerHTML = $headerHtml(resp);
      var leftHtml = div.querySelector('.portal-image-bar');
      var rightHtml = div.querySelector('.portal-access-info');

      if (!leftHtml || !rightHtml) {
        $log.debug('GetHelpCtrl: Not using the regular header HTML template.');
        vm.leftSide = $sce.trustAsHtml(div.innerHTML);
      } else {
        $log.debug('GetHelpCtrl: Found the regular header HTML template.');
        vm.leftSide = $sce.trustAsHtml(leftHtml.innerHTML);

        // Regex from here: http://www.regexlib.com/REDetails.aspx?regexp_id=607
        // Modified to allow the UNITED STATES country code of '1' only.
        // Modified to not mutate phone strings ending in " or </a>.
        // - Prevents html errors with existing tel links from api
        var rightHtmlWithTelLinks = rightHtml.innerHTML.replace(/1?-?(?:\([2-9]\d{2}\)\ ?|[2-9]\d{2}(?:\-?|\ ?))[2-9]\d{2}[- ]?\d{4}(?!"|<\/a>)/g, '<a href="tel:$&">$&</a>');
        vm.rightSide = $sce.trustAsHtml(rightHtmlWithTelLinks);
      }
    });
  }

  function setTelehealthContent(user) {
    vm.showTelehealth = user.telehealthProvider !== null;
    vm.telehealthProvider = user.telehealthProvider;

    if (vm.showTelehealth) {
      sendTelehealthAnalyticImpression();
    }
  }

  function sendTelehealthAnalyticImpression() {
    AuditSvc.generateTelehealthAuditEvent({ eventType: 'PROVIDER_IMPRESSION' });
  }

  function sendTelehealthAnalyticLinkVisit() {
    AuditSvc.generateTelehealthAuditEvent({ eventType: 'PROVIDER_LINK_VISIT' });
  }
}